import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { ClassesComponent } from "../../Components/Classes/ClassComponent";

export const Classes = () => {
  return (
    <Wrapper header={"Class"}>
      <ClassesComponent />
    </Wrapper>
  );
};
